<template>
  <div class="container-fluid basic-background">
    <h1 class="visually-hidden">{{ $t("imageGeneration") }}</h1>
    <!--  左側 -->
    <div class="row">
      <div class="col-lg-6 mb-4">
        <div class="block-card h-120">
          <ImageSettings
              @update-image="updateGeneratedImage"
              @update-current-prompt="updateCurrentPrompt"
              @update-loading="updateLoadingStatus"  
            />
        </div>
      </div>
      
      <!-- 右側：ImageDisplay -->
      <div class="col-lg-6 mb-4">
        <div class="block-card px-4 py-4 h-100 d-flex flex-column position-relative">
          <h4 class="text-left letter-2px mb-4">
            {{ $t("imageAreaTitle") }}
          </h4>
          <ImageDisplay :image-src="generatedImage" :is-loading="isLoading" />
        </div>
      </div>
    </div>

  </div>
</template>
  
<script>
import ImageSettings from "@/components/ImageSettings.vue";
import ImageDisplay from "@/components/ImageDisplay.vue";

export default {
  components: {
    ImageSettings,
    ImageDisplay,
  },
  data() {
    return {
      generatedImage: "",  // 儲存生圖的圖片 URL
      isLoading: false,    // 控制 ImageDisplay 的加載狀態
      currentPrompt: "",   // 儲存目前的 prompt
    };
  },
  methods: {
    updateGeneratedImage(image) {
      this.generatedImage = image;  // 更新圖片
    },
    updateCurrentPrompt(newPrompt) {
      this.currentPrompt = newPrompt;  // 更新 ChatLog 中顯示的 prompt
    },
    updateLoadingStatus(loading) {
      this.isLoading = loading;  // 更新加載狀態
    },
  },
};
</script>